import React, { PureComponent } from "react";
import RoundLink from "../../round-link";
import { Link } from "react-router";
import cn from "classnames";
import Auth from '../../../routes/Auth';
import EventEmitter from "../../../services/event-emitter";

import ArrowDropDown from "../../../containers/assets/arrow_drop_down.svg";
import DashboardIcon from "../../../containers/assets/left-menu-1.png";
import DashboardActiveIcon from "../../../containers/assets/left-menu-active-1.png";
import WelcomeIcon from "../../../containers/assets/left-menu-2.png";
import WelcomeActiveIcon from "../../../containers/assets/left-menu-active-2.png";
import ResearchIcon from "../../../containers/assets/left-menu-3.png";
import ResearchActiveIcon from "../../../containers/assets/left-menu-active-3.png";
import GoalsIcon from "../../../containers/assets/left-menu-4.png";
import GoalsActiveIcon from "../../../containers/assets/left-menu-active-4.png";
import DecisionsIcon from "../../../containers/assets/left-menu-5.png";
import DecisionsActiveIcon from "../../../containers/assets/left-menu-active-5.png";
import ResultsIcon from "../../../containers/assets/left-menu-6.png";
import ResultsActiveIcon from "../../../containers/assets/left-menu-active-6.png";
import TriviaIcon from "../../../containers/assets/left-menu-7.png";
import TriviaActiveIcon from "../../../containers/assets/left-menu-active-7.png";
import PeerReviewIcon from "../../../containers/assets/left-menu-8.png";
import PeerReviewActiveIcon from "../../../containers/assets/left-menu-active-8.png";
import GameSetupIcon from "../../../containers/assets/left-menu-9.png";
import GameSetupActiveIcon from "../../../containers/assets/left-menu-active-9.png";
import MonitoringIcon from "../../../containers/assets/left-menu-10.png";
import MonitoringActiveIcon from "../../../containers/assets/left-menu-active-10.png";

const renderLink = ({
  to,
  title,
  round,
  active,
  level,
  onClick,
  alignCenter,
  params
}, isMenuExpanded) => {
  if (round || params)
    return (
      <RoundLink
        to={to}
        round={round}
        onClick={onClick}
        className={cn({
          linksWrapper__mainLinkWrapper__link: level === 1,
          linksWrapper__subLinkWrapper__link: level > 1,
          linksWrapper__mainLinkWrapper_active: active && level === 1,
          linksWrapper__subLinkWrapper_active: active && level > 1,
          linksWrapper__subLinkWrapper_centered: alignCenter,
        })}
        params={params}
      >
        {menuIcon(title, isMenuExpanded)}
        {isMenuExpanded ? title : ''}
      </RoundLink>
    );
  else
    return (
      <Link
        to={to}
        onClick={onClick}
        className={cn({
          linksWrapper__mainLinkWrapper__link: level === 1,
          linksWrapper__subLinkWrapper__link: level > 1,
          linksWrapper__mainLinkWrapper_active: active && level === 1,
          linksWrapper__subLinkWrapper_active: active && level > 1,
        })}
      >
        {menuIcon(title, isMenuExpanded)}
        {isMenuExpanded ? title : ''}
      </Link>
    );
};

const menuIcon = (title, isMenuExpanded) => {
  if (Auth.getPosition() === 'Instructor') {
    if (title === 'Dashboard') {
      return (
        <span>
          <img src={DashboardIcon} alt="dashboard icon" className={cn('linksWrapper__symbol linksWrapper__symbol_default', {
            linksWrapper__symbol__collapsed: !isMenuExpanded,
          })} />
          <img src={DashboardActiveIcon} alt="dashboard icon" className={cn('linksWrapper__symbol linksWrapper__symbol_active', {
            linksWrapper__symbol__collapsed: !isMenuExpanded,
          })} />
        </span>
      );
    }

    if (title === 'Welcome') {
      return (
        <span>
          <img src={WelcomeIcon} alt="welcome icon" className={cn('linksWrapper__symbol linksWrapper__symbol_default', {
            linksWrapper__symbol__collapsed: !isMenuExpanded,
          })} />
          <img src={WelcomeActiveIcon} alt="welcome icon" className={cn('linksWrapper__symbol linksWrapper__symbol_active', {
            linksWrapper__symbol__collapsed: !isMenuExpanded,
          })} />
        </span>
      );
    }

    if (title === 'Game Admin') {
      return (
        <span>
          <img src={GameSetupIcon} alt="game setup icon" className={cn('linksWrapper__symbol linksWrapper__symbol_default', {
            linksWrapper__symbol__collapsed: !isMenuExpanded,
          })} />
          <img src={GameSetupActiveIcon} alt="game setup icon" className={cn('linksWrapper__symbol linksWrapper__symbol_active', {
            linksWrapper__symbol__collapsed: !isMenuExpanded,
          })} />
        </span>
      );
    }

    if (title === 'Monitoring') {
      return (
        <span>
          <img src={MonitoringIcon} alt="monitoring icon" className={cn('linksWrapper__symbol linksWrapper__symbol_default', {
            linksWrapper__symbol__collapsed: !isMenuExpanded,
          })} />
          <img src={MonitoringActiveIcon} alt="monitoring icon" className={cn('linksWrapper__symbol linksWrapper__symbol_active', {
            linksWrapper__symbol__collapsed: !isMenuExpanded,
          })} />
        </span>
      );
    }

    if (title === 'Results') {
      return (
        <span>
          <img src={ResultsIcon} alt="results icon" className={cn('linksWrapper__symbol linksWrapper__symbol_default', {
            linksWrapper__symbol__collapsed: !isMenuExpanded,
          })} />
          <img src={ResultsActiveIcon} alt="results icon" className={cn('linksWrapper__symbol linksWrapper__symbol_active', {
            linksWrapper__symbol__collapsed: !isMenuExpanded,
          })} />
        </span>
      );
    }

    return null;
  } else {
    if (title === 'Dashboard') {
      return (
        <span>
          <img src={DashboardIcon} alt="dashboard icon" className={cn('linksWrapper__symbol linksWrapper__symbol_default', {
            linksWrapper__symbol__collapsed: !isMenuExpanded,
          })} />
          <img src={DashboardActiveIcon} alt="dashboard icon" className={cn('linksWrapper__symbol linksWrapper__symbol_active', {
            linksWrapper__symbol__collapsed: !isMenuExpanded,
          })} />
        </span>
      );
    }

    if (title === 'Welcome') {
      return (
        <span>
          <img src={WelcomeIcon} alt="welcome icon" className={cn('linksWrapper__symbol linksWrapper__symbol_default', {
            linksWrapper__symbol__collapsed: !isMenuExpanded,
          })} />
          <img src={WelcomeActiveIcon} alt="welcome icon" className={cn('linksWrapper__symbol linksWrapper__symbol_active', {
            linksWrapper__symbol__collapsed: !isMenuExpanded,
          })} />
        </span>
      );
    }

    if (title === 'Research') {
      return (
        <span>
          <img src={ResearchIcon} alt="research icon" className={cn('linksWrapper__symbol linksWrapper__symbol_default', {
            linksWrapper__symbol__collapsed: !isMenuExpanded,
          })} />
          <img src={ResearchActiveIcon} alt="research icon" className={cn('linksWrapper__symbol linksWrapper__symbol_active', {
            linksWrapper__symbol__collapsed: !isMenuExpanded,
          })} />
        </span>
      );
    }

    if (title === 'Goals & Targets') {
      return (
        <span>
          <img src={GoalsIcon} alt="goals icon" className={cn('linksWrapper__symbol linksWrapper__symbol_default', {
            linksWrapper__symbol__collapsed: !isMenuExpanded,
          })} />
          <img src={GoalsActiveIcon} alt="goals icon" className={cn('linksWrapper__symbol linksWrapper__symbol_active', {
            linksWrapper__symbol__collapsed: !isMenuExpanded,
          })} />
        </span>
      );
    }

    if (title === 'Decisions') {
      return (
        <span>
          <img src={DecisionsIcon} alt="decisions icon" className={cn('linksWrapper__symbol linksWrapper__symbol_default', {
            linksWrapper__symbol__collapsed: !isMenuExpanded,
          })} />
          <img src={DecisionsActiveIcon} alt="decisions icon" className={cn('linksWrapper__symbol linksWrapper__symbol_active', {
            linksWrapper__symbol__collapsed: !isMenuExpanded,
          })} />
        </span>
      );
    }

    if (title === 'Results') {
      return (
        <span>
          <img src={ResultsIcon} alt="results icon" className={cn('linksWrapper__symbol linksWrapper__symbol_default', {
            linksWrapper__symbol__collapsed: !isMenuExpanded,
          })} />
          <img src={ResultsActiveIcon} alt="results icon" className={cn('linksWrapper__symbol linksWrapper__symbol_active', {
            linksWrapper__symbol__collapsed: !isMenuExpanded,
          })} />
        </span>
      );
    }

    if (title === 'Trivia') {
      return (
        <span>
          <img src={TriviaIcon} alt="trivia icon" className={cn('linksWrapper__symbol linksWrapper__symbol_default', {
            linksWrapper__symbol__collapsed: !isMenuExpanded,
          })} />
          <img src={TriviaActiveIcon} alt="trivia icon" className={cn('linksWrapper__symbol linksWrapper__symbol_active', {
            linksWrapper__symbol__collapsed: !isMenuExpanded,
          })} />
        </span>
      );
    }

    if (title === 'Peer Review') {
      return (
        <span>
          <img src={PeerReviewIcon} alt="peer-review icon" className={cn('linksWrapper__symbol linksWrapper__symbol_default', {
            linksWrapper__symbol__collapsed: !isMenuExpanded,
          })} />
          <img src={PeerReviewActiveIcon} alt="peer-review icon" className={cn('linksWrapper__symbol linksWrapper__symbol_active', {
            linksWrapper__symbol__collapsed: !isMenuExpanded,
          })} />
        </span>
      );
    }

    return null;
  }
}

class LinkWithSubLink extends PureComponent {

  constructor(props) {
    super(props);

    this.eventemitter = EventEmitter.getInstance();
  }

  componentDidMount() {
    this.eventemitter.on('collapse-submenu', this.collapseSubmenu);
    this.eventemitter.on('submenu-click', this.submenuClick);
    this.eventemitter.on('activate-submenu', this.activateSubmenu);
    document.addEventListener('mousedown', this.clickOutside);

    if (this.props.link.active && this.props.isMenuExpanded) {
      requestAnimationFrame(() => {
        const submenuHeight = this.submenu.scrollHeight;
        this.submenu.style.height = `${submenuHeight}px`;
        this.submenu.style.opacity = 100;
      });
    }
  }

  activateSubmenu = () => {
    if (this.props.link.active && this.props.isMenuExpanded) {
      requestAnimationFrame(() => {
        const submenuHeight = this.submenu.scrollHeight;
        this.submenu.style.height = `${submenuHeight}px`;
        this.submenu.style.opacity = 100;
      });
    } else if (this.props.link.active) {
      requestAnimationFrame(() => {
        const submenuHeight = Number(this.submenu.style.height.replace('px', ''));
        if (submenuHeight > 0) {
          this.submenu.style.height = '0px';
          this.submenu.style.opacity = 0;
        }
      });
    }
  }

  clickOutside = (event) => {
    if (!this.props.isMenuExpanded && this.submenu && !this.submenu.contains(event.target)) {
      requestAnimationFrame(() => {
        const submenuHeight = Number(this.submenu.style.height.replace('px', ''));
        if (submenuHeight > 0) {
          this.submenu.style.height = '0px';
          this.submenu.style.opacity = 0;
        }
      });
    }
  }

  componentWillUnmount() {
    this.eventemitter.off('collapse-submenu', this.collapseSubmenu);
    this.eventemitter.off('submenu-click', this.submenuClick);
    this.eventemitter.off('activate-submenu', this.activateSubmenu);
    document.removeEventListener('mousedown', this.clickOutside);
  }

  setRef = submenu => {
    this.submenu = submenu;
  }

  submenuClick = () => {
    if (this.props.link.active && this.props.isMenuExpanded) {
      requestAnimationFrame(() => {
        const submenuHeight = this.submenu.scrollHeight;
        this.submenu.style.height = `${submenuHeight}px`;
        this.submenu.style.opacity = 100;
      });
    } else {
      requestAnimationFrame(() => {
        this.submenu.style.height = '0px';
        this.submenu.style.opacity = 0;
      });
    }
  }

  collapseSubmenu = (linkId) => {
    if (this.props.isMenuExpanded) {
      if (this.props.link.active) {
        requestAnimationFrame(() => {
          const submenuHeight = this.submenu.scrollHeight;
          this.submenu.style.height = `${submenuHeight}px`;
          this.submenu.style.opacity = 100;
        });
      } else {
        requestAnimationFrame(() => {
          this.submenu.style.height = '0px';
          this.submenu.style.opacity = 0;
        });
      }
    } else if (linkId === this.props.link.id) {
      requestAnimationFrame(() => {
        const submenuHeight = this.submenu.scrollHeight;
        this.submenu.style.height = `${submenuHeight}px`;
        this.submenu.style.opacity = 100;
      });
    }
  }

  toggle = callback => {
    return () => {
      callback();

      const submenuHeight = this.submenu.scrollHeight;
      const currentHeight = Number(this.submenu.style.height.replace('px', '').trim());

      if (currentHeight > 0) {
        requestAnimationFrame(() => {
          this.submenu.style.height = '0px';
          this.submenu.style.opacity = 0;
        });
      } else {
        requestAnimationFrame(() => {
          this.submenu.style.height = `${submenuHeight}px`;
          this.submenu.style.opacity = 100;
        });
      }
    }
  }

  render() {
    const { link, isMenuExpanded } = this.props;
    const subLinksActive = link.links.some(subLink => subLink.active);

    return (
      <div>
        <div className="linksWrapper__mainLinkWrapper" onClick={this.toggle(link.onClick)}>
          <button
            className={cn("linksWrapper__mainLinkWrapper__link", {
              linksWrapper__mainLinkWrapper_active: isMenuExpanded ? link.active && !subLinksActive : link.active,
            })}
          >
            {menuIcon(link.title, isMenuExpanded)}
            {isMenuExpanded ? link.title : ''}
            <svg
              className={cn("linksWrapper__icon", {
                linksWrapper__iconActive: link.active,
                linksWrapper__iconHidden: !isMenuExpanded,
              })}
            >
              <use xlinkHref={`${ArrowDropDown}#arrow`} />
            </svg>
          </button>
        </div>
        <div ref={this.setRef} className={cn('linksWrapper__subLinkWrapper', {
          linksWrapper__subLinkWrapper__collapsed: !isMenuExpanded,
        })}>
          {link.links.map(link => (
            <span key={link.id}>
              {renderLink(link, true)}
            </span>
          )
          )}
        </div>
      </div>
    );
  }
}

class LinksWrapper extends PureComponent {
  constructor(props) {
    super(props);

    const links = this.initiateLinks();
    const activeLink = links.find(i => !!i.active);

    this.state = {
      links,
      lastClickedId: activeLink ? activeLink.id : null,
    };
    this.eventemitter = EventEmitter.getInstance();
  }

  componentDidUpdate(prevProps) {
    const { position } = this.props;
    if (
      position !== prevProps.position ||
      JSON.stringify(this.props.links) !== JSON.stringify(prevProps.links)
    ) {
      const links = this.initiateLinks();
      const activeLink = links.find(i => !!i.active);

      this.setState({
        links,
        lastClickedId: activeLink ? activeLink.id : null,
      });
    }
  }

  isMainLinkActive = (link, pathname) => {
    const { currentRound, roundInUrl } = this.props;
    const roundNumber = roundInUrl || currentRound;
    const isInstructor = Auth.getPosition() === 'Instructor';
    const compareRound = pathname.startsWith('/analysis/team-reports') && !isInstructor ? true : false;
    const alternatives = link.alternatives || [];

    if (compareRound) {
      return !!link.innerLinks
        ? link.innerLinks.some(subLink => [...(subLink.alternatives || []), subLink.to].some(path => pathname.startsWith(path)) && subLink.round === roundNumber)
        : [...alternatives, link.to].some(path => pathname.startsWith(path)) && link.round === roundNumber;
    }

    return !!link.innerLinks
      ? link.innerLinks.some(subLink => [...(subLink.alternatives || []), subLink.to].some(path => pathname.startsWith(path)))
      : [...alternatives, link.to].some(path => pathname.startsWith(path));
  }

  isSubLinkActive = (subLink, pathname) => {
    const { currentRound, roundInUrl } = this.props;
    const roundNumber = roundInUrl || currentRound;
    const isInstructor = Auth.getPosition() === 'Instructor';
    const compareRound = pathname.startsWith('/analysis/team-reports') && !isInstructor ? true : false;
    const alternatives = subLink.alternatives || [];

    return compareRound
      ? [...alternatives, subLink.to].some(path => pathname.startsWith(path)) && subLink.round === roundNumber
      : [...alternatives, subLink.to].some(path => pathname.startsWith(path));
  }

  initiateLinks = () => {
    const { links: rawLinks, location } = this.props;
    const filteredLinks = rawLinks.filter(link => link.hide !== true);

    return filteredLinks.map((link, index) => ({
      id: `main-link-${link.to}_${index}`,
      to: link.to,
      round: link.round,
      title: link.title,
      active: this.isMainLinkActive(link, location.pathname),
      alternatives: link.alternatives,
      level: 1,
      ...(!!link.innerLinks ? {
        links: link.innerLinks.map((subLink, subIndex) => ({
          id: `sub-link-${index}-${subIndex}`,
          to: subLink.to,
          round: subLink.round,
          title: subLink.title,
          active: this.isSubLinkActive(subLink, location.pathname),
          alternatives: subLink.alternatives,
          level: 2,
          alignCenter: subLink.alignCenter,
          params: subLink.params,
          onClick: () => this.setActive(index, subIndex, `main-link-${link.to}_${index}`, true, `sub-link-${index}-${subIndex}`),
        })),
      } : {}),
      onClick: () => this.setActive(index, -1, `main-link-${link.to}_${index}`, false, `main-link-${link.to}_${index}`),
    }));
  };

  setActive = (index, subIndex, lastClickedId, clickFromSubmenu, linkId) => {
    this.setState(prevState => ({
      lastClickedId,
      links: prevState.links.map((link, i) => ({
        ...link,
        active: !!link.links
          ? (
            prevState.lastClickedId === lastClickedId && link.id === lastClickedId && subIndex === -1
              ? !link.active
              : (
                (subIndex === -1 && index === i)
                || link.links.some((subLink, j) => i === index && j === subIndex)
              )
          )
          : subIndex === -1 && index === i,
        ...(!!link.links ? {
          links: link.links.map((subLink, j) => ({
            ...subLink,
            active: i === index && j === subIndex,
          })),
        } : {}),
      })),
    }), () => {
      if (clickFromSubmenu) {
        this.eventemitter.trigger('submenu-click');
      } else {
        this.eventemitter.trigger('collapse-submenu', [linkId]);
      }
    });
  }

  render() {
    const { links } = this.state;
    const { isMenuExpanded } = this.props;

    return (
      <div className="linksWrapper">
        {links.map(link => !!link.links ? (
          <LinkWithSubLink
            key={link.id}
            link={link}
            isMenuExpanded={isMenuExpanded}
          />
        ) : (
          <div
            key={link.id}
            className="linksWrapper__mainLinkWrapper"
          >
            {renderLink(link, isMenuExpanded)}
          </div>
        ))}
      </div>
    );
  }
}

LinksWrapper.defaultProps = {
  position: ""
};

export default LinksWrapper;



// WEBPACK FOOTER //
// ./src/components/navigation/leftbar/LinksWrapper.js